<template>
	<tr>
		<td>
			<b-link
				href="#"
				title="Open this job"
				:to="{
					name: 'jobupdate',
					params: { id: job.Id },
				}"
				>{{ job.Id }}</b-link
			>
		</td>
		<td>{{ job.Clock.Name }}</td>
		<td>{{ jobTypeName }}</td>
		<td>{{ job.Status.Name }}</td>
		<td>{{ job.QuotesTotal != null ?  job.QuotesTotal : 0 }}</td>
		<td>{{ formatDate(job.Due) }}</td>
	</tr>
</template>
<script>
// import shared functions

import { dateFuncs } from "@/globs.js";

export default {
	name: "JobListRow",

	props: ["job", "jobTypes"],

	computed: {
		jobTypeName() {
			return this.jobTypes
				.filter((q) => q.Value == this.job.Type)
				.map(function (obj) {
					return obj.DisplayName;
				})
				.join();
		},
	},

	methods: {
		formatDate(date) {
			return dateFuncs.backEndDateFormat(date);
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/job/job-list-row.vue